import { Parameter, Parameters, parseParameterValue } from '../types';

/**
 * Core parameter fetching logic that can be used by both web and mobile
 * @param supabase - The Supabase client instance
 * @param communityId - The community ID to fetch parameters for
 */
export async function fetchParameters(supabase: any, communityId: string | undefined) {
  if (!communityId) return { parameters: {} as Parameters };

  const { data, error } = await supabase
    .from('parameters')
    .select('*')
    .eq('community_id', communityId);

  if (error) throw error;

  // Convert array to mapped object
  const mappedParameters: Parameters = {};
  data.forEach((param: Parameter) => {
    mappedParameters[param.key] = {
      value: parseParameterValue(param.value, param.type),
      type: param.type
    };
  });

  return { parameters: mappedParameters };
}

/**
 * Creates a parameters query key for React Query
 */
export function createParametersQueryKey(communityId: string | undefined) {
  return ['parameters', communityId];
}